import PropTypes from 'prop-types';
import HistorySection from '../../HistorySection';
import { Text } from '@zillow/constellation';
import numeral from 'numeral';

export const NO_ADDRESS_MSG = 'No address details provided';

function getHeading(type) {
  if (type === 'rent') {
    return 'Rental home';
  }
  if (type === 'own') {
    return 'Owned home';
  }

  return 'Other home';
}

function getAddressString(street, city, state) {
  const addressParts = [street, city, state].filter(Boolean);
  if (addressParts.length === 0) {
    return NO_ADDRESS_MSG;
  }
  return street || null;
}

function getCityStateString(city, state) {
  const addressParts = [city, state].filter(Boolean);
  if (addressParts.length === 0) {
    return null;
  }

  return addressParts.join(', ');
}

function getContactInfo(type, manager, description) {
  switch (type) {
    case 'rent':
      return {
        title: 'Rental manager',
        name: manager.name,
        email: manager.email,
        phone: manager.phone,
      };
    case 'other': {
      // Re-using the ContactInfo component for styling
      return {
        title: 'Description',
        name: description || 'No description provided',
      };
    }
    case 'own':
    default:
      return null;
  }
}

export default function ResidenceSection({ residence, className = null }) {
  const { startDate, endDate, type, manager, address, monthlyPayment, description } = residence;
  const { street, city, state } = address;
  const heading = getHeading(type);
  return (
    <HistorySection
      className={className}
      startDate={startDate}
      endDate={endDate}
      heading={heading}
      body={[
        monthlyPayment
          ? [
              numeral(monthlyPayment).format('$0,0'),
              <Text key="per-month" aria-label="per month">
                /mo
              </Text>,
            ]
          : null,
        getAddressString(street, city, state),
        getCityStateString(city, state),
      ]}
      contactInfo={getContactInfo(type, manager, description)}
    />
  );
}

ResidenceSection.propTypes = {
  residence: PropTypes.shape({
    type: PropTypes.oneOf(['rent', 'own', 'other']).isRequired,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    monthlyPayment: PropTypes.string,
    description: PropTypes.string,
    manager: PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string,
      phone: PropTypes.string,
    }),
    address: PropTypes.shape({
      street: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
    }).isRequired,
  }),
  className: PropTypes.string,
};
